import React from "react";
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const CategoriesWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/category/categories/CategoriesWrap')
)

const TemplatesWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/category/category/templates/TemplatesWrap')
)

const CampaignWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/campaigns/campaign/CampaignWrap')
)


const CategoryRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/categories' component={CategoriesWrap} />
    <Route exact path='/marketing-blast/category/:id/templates' component={TemplatesWrap} />
    <Route exact path='/marketing-blast/category/:category_id/template/:id' component={CampaignWrap} />
    <Route exact path='/marketing-blast/category/:category_id/template/:id/readonly' component={CampaignWrap} />
  </Switch>
)

export default CategoryRoutes;